export const tro15DataEn = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://www.wm.com/us/en/dumpster-rental/15-yard",
      url: "https://www.wm.com/us/en/dumpster-rental/15-yard",
      name: "15 Yard Dumpster Rental | WM",
      primaryImageOfPage: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/15-yard/#primaryimage",
      },
      image: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/15-yard/#primaryimage",
      },
      thumbnailUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/15-yard/15-yd-header.jpg",
      description:
        "Our 15 yard dumpster rentals are the perfect solution for basement and garage cleanout projects. Schedule your rental online today.",
    },
    {
      "@type": "ImageObject",
      inLanguage: "en-US",
      "@id": "https://www.wm.com/us/en/dumpster-rental/15-yard/#primaryimage",
      url: "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/15-yard/15-yd-header.jpg",
      contentUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/15-yard/15-yd-header.jpg",
      width: 545,
      height: 327,
      caption: "15 yard dumpster dimensions",
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.wm.com/us/en/dumpster-rental/15-yard/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.wm.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Dumpster Rental",
          item: "https://www.wm.com/us/en/dumpster-rental",
        },
        { "@type": "ListItem", position: 3, name: "15-Yard" },
      ],
    },
  ],
}

export const tro15ProductDataEn = {
  "@context": "https://schema.org",
  "@type": "Product",
  "@id": "https://www.wm.com/us/en/dumpster-rental/15-yard/#product",
  name: "15 Yard Dumpster Rental | WM",
  image:
    "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/15-yard/15-yd-header.jpg",
  description:
    "Our 15 yard dumpsters are convenient solutions for mid-range projects like cleaning out a couple of rooms or emptying a garage. Typically measuring 10’ x 7’11” x 4’7”, the 15 yard dumpster can hold roofing debris, deck materials, and other heavy products you’re ready to clean out.",
  url: "https://www.wm.com/us/en/dumpster-rental/15-yard",
  mainEntityOfPage: "https://www.wm.com/us/en/dumpster-rental/15-yard",
  isRelatedTo: [
    "10 Yard Dumpster",
    "12 Yard Dumpster",
    "20 Yard Dumpster",
    "30 Yard Dumpster",
    "40 Yard Dumpster",
  ],
  brand: { "@type": "Brand", "@id": "https://www.wm.com/#brand" },
}
